import { render, staticRenderFns } from "./UpdateMargin.vue?vue&type=template&id=657889e6"
import script from "./UpdateMargin.vue?vue&type=script&lang=js"
export * from "./UpdateMargin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports